import { showTimePopover } from './timePopover.js';

/**
 * Time picker column UI.
 */

export function renderTime(picker) {
  const $ = window.jQuery;
  const isCompact = picker.config.compactTime;
  const $time = $(`<div class="gdp-time-picker ${isCompact ? 'gdp-compact' : ''}"></div>`);
  const date = picker.state.currentDate;

  const currentHours = date ? date.getHours() : null;
  const currentMinutes = date ? date.getMinutes() : null;

  const $hours = renderTimeColumn(picker, 'H', currentHours, 23, (val) => {
    if (!picker.state.currentDate) {
      picker.state.currentDate = new Date(picker.state.viewDate);
    }
    picker.state.currentDate.setHours(val);
    picker._selectDate();
  });

  const $minutes = renderTimeColumn(picker, 'M', currentMinutes, 59, (val) => {
    if (!picker.state.currentDate) {
      picker.state.currentDate = new Date(picker.state.viewDate);
    }
    picker.state.currentDate.setMinutes(val);
    picker._selectDate();
  });

  $time.append($hours, '<div class="gdp-time-sep">:</div>', $minutes);

  if (picker.config.components.seconds) {
    const currentSeconds = date ? date.getSeconds() : null;
    const $seconds = renderTimeColumn(picker, 'S', currentSeconds, 59, (val) => {
      if (!picker.state.currentDate) {
        picker.state.currentDate = new Date(picker.state.viewDate);
      }
      picker.state.currentDate.setSeconds(val);
      picker._selectDate();
    });
    $time.append('<div class="gdp-time-sep">:</div>', $seconds);
  }

  return $time;
}

export function renderTimeColumn(picker, type, current, max, onChange) {
  const $ = window.jQuery;
  const isCompact = picker.config.compactTime;
  const $col = $('<div class="gdp-time-col"></div>');
  const $up = $('<button type="button" class="gdp-time-btn"><i class="bi bi-chevron-up"></i></button>');
  const displayText = current !== null ? current.toString().padStart(2, '0') : '--';
  const $val = $(`<div class="gdp-time-val" title="Click to select">${displayText}</div>`);
  const $down = $('<button type="button" class="gdp-time-btn"><i class="bi bi-chevron-down"></i></button>');

  $val.on('click', (e) => {
    e.stopPropagation();
    showTimePopover(picker, $val, type, max, current, onChange);
  });

  const getFilter = () => {
    if (type === 'H') return picker.config.filters.hour;
    if (type === 'M') return picker.config.filters.minute;
    if (type === 'S') return picker.config.filters.second;
    return null;
  };

  const findNextValid = (val, dir) => {
    const filter = getFilter();
    let next = val;
    for (let i = 0; i <= max; i++) {
      next = next + dir;
      if (next > max) next = 0;
      if (next < 0) next = max;
      if (!filter || filter(next)) return next;
    }
    return val;
  };

  $up.on('click', () => {
    const raw = $val.text();
    let v = raw === '--' ? 0 : parseInt(raw, 10);
    v = findNextValid(v, 1);
    $val.text(v.toString().padStart(2, '0'));
    onChange(v);
  });

  $down.on('click', () => {
    const raw = $val.text();
    let v = raw === '--' ? 0 : parseInt(raw, 10);
    v = findNextValid(v, -1);
    $val.text(v.toString().padStart(2, '0'));
    onChange(v);
  });

  if (isCompact) {
    const $prev = $('<button type="button" class="gdp-time-btn-sm"><i class="bi bi-chevron-left"></i></button>');
    const $next = $('<button type="button" class="gdp-time-btn-sm"><i class="bi bi-chevron-right"></i></button>');

    $prev.on('click', (e) => {
      e.stopPropagation();
      $down.trigger('click');
    });
    $next.on('click', (e) => {
      e.stopPropagation();
      $up.trigger('click');
    });

    $col.addClass('gdp-time-col-compact').append($prev, $val, $next);
  } else {
    $col.append($up, $val, $down);
  }
  return $col;
}
